import { ValidationRuleFunction } from 'vee-validate/dist/types/types';
import isURL from 'validator/lib/isURL';

const url: ValidationRuleFunction = value => {
  return isURL(`${value}`, {
    protocols: ['http', 'https'],
    require_protocol: true,
  });
};
export default url;
